<template>
  <div>
  <v-dialog v-model="dialogCropStudent" persistent scrollable max-width="700px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Recortar Fotografía</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <clipper-fixed
          class="basic lg"
          :src="cropImageURL"
          ref="clipperStudent"
          :rotate="degrees"
          :round="true"
          preview="previewStudent"
        ></clipper-fixed>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-col>
          <v-row class="justify-center mr-6">
            <v-slider
              v-model="degrees"
              label="Grados"
              step="1"
              max="180"
              min="-180"
              thumb-label="always"
            ></v-slider>
          </v-row>
          <v-row class="justify-center">
            <v-btn color="primary" @click="getCutingStudentProfile()">Recortar</v-btn>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-container fluid class="py-6">
    <div class="d-flex align-center mb-6">
      <v-btn icon color="primary" class="mr-3 bg-primary-light" elevation="2" @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div>
        <h1 class="text-h5 font-weight-bold primary--text mb-0">
          Registro Directo de Estudiantes
        </h1>
        <span class="text-caption grey--text font-weight-medium">
          Asigna estudiantes simultáneamente a dos tutores existentes.
        </span>
      </div>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <!-- TUTORES SECTION -->
        <v-col cols="12">
          <v-card class="elevation-4 rounded-xl mb-4">
            <v-toolbar flat color="transparent" class="px-4 pt-2">
              <v-icon left color="primary">mdi-account-multiple</v-icon>
              <v-toolbar-title class="font-weight-bold primary--text">Selección de Tutores</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-6">
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="idTutor1"
                    :items="usersTutor1"
                    :search-input.sync="searchTutor1"
                    :loading="loadingTutor1"
                    item-value="id"
                    item-text="email"
                    label="Tutor 1 (Requerido)"
                    placeholder="Escribe para buscar por email o nombre"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    no-filter
                    :rules="[v => !!v || 'Tutor 1 es requerido']"
                    return-object
                  >
                    <template v-slot:selection="{ item }">
                      {{ item.first_name }} {{ item.last_name }} ({{ item.email }})
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.first_name }} {{ item.last_name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="idTutor2"
                    :items="usersTutor2"
                    :search-input.sync="searchTutor2"
                    :loading="loadingTutor2"
                    item-value="id"
                    item-text="email"
                    label="Tutor 2 (Requerido)"
                    placeholder="Escribe para buscar por email o nombre"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    no-filter
                    :rules="[
                      v => !!v || 'Tutor 2 es requerido',
                      v => (v && idTutor1 && v.id !== idTutor1.id) || 'Debe ser un tutor diferente'
                    ]"
                    return-object
                  >
                    <template v-slot:selection="{ item }">
                      {{ item.first_name }} {{ item.last_name }} ({{ item.email }})
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.first_name }} {{ item.last_name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- ESTUDIANTES SECTION -->
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between mb-4">
            <h2 class="text-h6 font-weight-bold primary--text">
              <v-icon color="primary" class="mr-2">mdi-account-school</v-icon>
              Estudiantes a Registrar
            </h2>
            <v-btn color="secondary" rounded @click="addStudent">
              <v-icon left>mdi-plus</v-icon> Agregar Estudiante
            </v-btn>
          </div>

          <transition-group name="fade-slide" tag="div">
            <v-card 
              v-for="(student, index) in students" 
              :key="student._uid"
              class="elevation-3 rounded-xl mb-6 student-card border-l-4-primary"
            >
              <v-card-title class="d-flex justify-space-between pb-0">
                <span class="text-subtitle-1 font-weight-bold">Estudiante #{{ index + 1 }}</span>
                <v-btn icon color="error" @click="removeStudent(index)" :disabled="students.length === 1">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-title>
              
              <v-card-text class="pt-4">
                <v-row>
                  <!-- Nombres y Apellidos -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="student.first_name"
                      label="Nombres *"
                      outlined
                      dense
                      :rules="[v => !!v || 'Nombres son requeridos']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="student.last_name"
                      label="Apellidos *"
                      outlined
                      dense
                      :rules="[v => !!v || 'Apellidos son requeridos']"
                    ></v-text-field>
                  </v-col>

                  <!-- Escuela y Salón -->
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="student.idSchool"
                      :items="schools"
                      item-text="name"
                      item-value="id"
                      label="Escuela *"
                      outlined
                      dense
                      :rules="[v => !!v || 'Escuela es requerida']"
                      @change="onSchoolChange(student)"
                    >
                      <template v-slot:selection="data">
                        <div class="d-flex align-center">
                          <v-avatar size="24" class="mr-2" v-if="data.item.logo">
                            <img :src="data.item.logo" alt="">
                          </v-avatar>
                          <span>{{ data.item.name }}</span>
                        </div>
                      </template>
                      <template v-slot:item="data">
                        <div class="d-flex align-center">
                          <v-avatar size="32" class="mr-3" v-if="data.item.logo">
                            <img :src="data.item.logo" alt="">
                          </v-avatar>
                          <span>{{ data.item.name }}</span>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="student.idClassroom"
                      :items="student.classrooms || []"
                      item-text="name"
                      item-value="id"
                      label="Salón (Opcional)"
                      outlined
                      dense
                      clearable
                    >
                      <template v-slot:selection="data">
                        {{ data.item.grade_name }} - {{ data.item.name }}
                      </template>
                      <template v-slot:item="data">
                        <v-list-item-content>
                          <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                          <v-list-item-subtitle>{{ data.item.grade_name }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!-- Avatar -->
                  <v-col cols="12" class="text-center">
                    <v-label>Fotografía del Estudiante *</v-label>
                    <br>
                    <v-avatar class="my-3" color="grey" size="160">
                      <v-img :src="student.avatarBase64" v-if="student.avatarBase64"></v-img>
                      <v-icon v-else size="64" color="white">mdi-account</v-icon>
                    </v-avatar>
                    <br>
                    <v-btn color="primary">
                      <clipper-upload
                        @input="openCropDialog(index)"
                        accept="image/*"
                        v-model="cropImageURL"
                      >
                        Subir Foto
                      </clipper-upload>
                    </v-btn>
                    <div v-if="!student.avatarBase64" class="caption error--text mt-1">
                      Fotografía es requerida
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </transition-group>
        </v-col>

        <!-- ACTIONS -->
        <v-col cols="12" class="text-right mt-4">
          <v-btn large text color="grey" class="mr-4" @click="$router.go(-1)">Cancelar</v-btn>
          <v-btn 
            large 
            color="primary" 
            class="px-8 rounded-pill" 
            elevation="4" 
            :loading="loadingSubmit" 
            @click="submitForm"
          >
            <v-icon left>mdi-content-save</v-icon>
            Registrar Estudiantes
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
  </div>
</template>

<script>
import { HTTP } from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'DirectRegistration',
  data() {
    return {
      valid: false,
      loadingSubmit: false,

      // Recorte de foto estudiante
      dialogCropStudent: false,
      cropStudentIndex: -1,
      cropImageURL: '',
      degrees: 0,

      // Tutor 1 Search
      idTutor1: null,
      searchTutor1: null,
      usersTutor1: [],
      loadingTutor1: false,

      // Tutor 2 Search
      idTutor2: null,
      searchTutor2: null,
      usersTutor2: [],
      loadingTutor2: false,

      // Catalogos
      schools: [],

      // Estudiantes
      students: [
        { _uid: Date.now(), first_name: '', last_name: '', idSchool: null, idClassroom: null, avatarFile: null, avatarBase64: null, classrooms: [] }
      ],
      uuidCounter: 1,

      timeoutTutor1: null,
      timeoutTutor2: null,
    }
  },
  watch: {
    searchTutor1(val) {
      if (this.timeoutTutor1) clearTimeout(this.timeoutTutor1);
      if (!val || val.length < 3) return;
      this.timeoutTutor1 = setTimeout(() => {
        this.fetchUsers(val, 1);
      }, 500);
    },
    searchTutor2(val) {
      if (this.timeoutTutor2) clearTimeout(this.timeoutTutor2);
      if (!val || val.length < 3) return;
      this.timeoutTutor2 = setTimeout(() => {
        this.fetchUsers(val, 2);
      }, 500);
    }
  },
  created() {
    this.fetchSchools();
  },
  methods: {
    getEmptyStudent() {
      this.uuidCounter = (this.uuidCounter || 0) + 1;
      return {
        _uid: Date.now() + this.uuidCounter,
        first_name: '',
        last_name: '',
        idSchool: null,
        idClassroom: null,
        avatarFile: null,
        avatarBase64: null,
        classrooms: [],
      }
    },
    addStudent() {
      this.students.push(this.getEmptyStudent());
    },
    removeStudent(index) {
      if (this.students.length > 1) {
        this.students.splice(index, 1);
      }
    },
    openCropDialog(index) {
      this.cropStudentIndex = index;
      this.degrees = 0;
      this.dialogCropStudent = true;
    },
    getCutingStudentProfile() {
      const canvas = this.$refs.clipperStudent.clip();
      const base64 = canvas.toDataURL('image/jpeg', 0.8);
      this.$set(this.students[this.cropStudentIndex], 'avatarBase64', base64);
      this.dialogCropStudent = false;
      this.cropImageURL = '';
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) { u8arr[n] = bstr.charCodeAt(n); }
      return new File([u8arr], filename, { type: mime });
    },
    fetchUsers(val, tutorIndex) {
      if (tutorIndex === 1) this.loadingTutor1 = true;
      else this.loadingTutor2 = true;

      HTTP.get('guests/filter/many?search=' + val, {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      })
      .then(res => {
        if (tutorIndex === 1) this.usersTutor1 = res.data.results || res.data;
        else this.usersTutor2 = res.data.results || res.data;
      })
      .catch(err => {
        console.error("Error fetching users", err);
      })
      .finally(() => {
        if (tutorIndex === 1) this.loadingTutor1 = false;
        else this.loadingTutor2 = false;
      });
    },
    fetchSchools() {
      HTTP.get('school/no_permission/', {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      })
      .then(res => {
        this.schools = res.data;
      })
      .catch(err => console.error(err));
    },
    onSchoolChange(student) {
      student.idClassroom = null;
      if (!student.idSchool) {
        this.$set(student, 'classrooms', []);
        return;
      }
      HTTP.get(`https://escuela-service.intrare.app/classroom/school/${student.idSchool}/`, {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      })
      .then(res => {
        this.$set(student, 'classrooms', res.data);
      })
      .catch(err => console.error(err));
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showSnackbar("Por favor completa los campos requeridos", "warning");
        return;
      }

      // Validar que todos los estudiantes tengan foto
      const missingPhoto = this.students.some(s => !s.avatarBase64);
      if (missingPhoto) {
        this.showSnackbar("Todos los estudiantes deben tener fotografía", "warning");
        return;
      }

      const formData = new FormData();
      formData.append('idTutor1', this.idTutor1.id);
      formData.append('idTutor2', this.idTutor2.id);

      this.students.forEach((s, i) => {
        formData.append(`student[${i}]first_name`, s.first_name);
        formData.append(`student[${i}]last_name`, s.last_name);
        formData.append(`student[${i}]idSchool`, s.idSchool);
        if (s.idClassroom) {
          formData.append(`student[${i}]idClassroom`, s.idClassroom);
        }
        if (s.avatarBase64) {
          const avatarFile = this.dataURLtoFile(s.avatarBase64, `avatar_student_${i}.jpeg`);
          formData.append(`student[${i}]avatar`, avatarFile);
        }
      });

      this.loadingSubmit = true;

      try {
        await HTTP.post('preregistration/direct/', formData, {
          headers: {
            'authorization': 'Token ' + store.getters.getToken,
            'Content-Type': 'multipart/form-data'
          }
        });
        this.showSnackbar("¡Registro exitoso!", "success");
        // Reset form
        this.idTutor1 = null;
        this.idTutor2 = null;
        this.students = [this.getEmptyStudent()];
        this.$refs.form.resetValidation();
      } catch (err) {
        console.error(err);
        this.showSnackbar("Error al registrar estudiantes", "error");
      } finally {
        this.loadingSubmit = false;
      }
    },
    showSnackbar(message, color) {
      this.$store.commit('snackbar_change_message', message);
      this.$store.commit('snackbar_change_color', color);
      this.$store.commit('snackbar_activate_true');
      setTimeout(() => {
        this.$store.commit('snackbar_activate_false');
      }, 4000);
    }
  }
}
</script>

<style scoped>
.border-l-4-primary {
  border-left: 4px solid var(--v-primary-base);
}
.bg-primary-light {
  background-color: rgba(var(--v-primary-base), 0.08) !important;
}
.student-card {
  transition: all 0.3s ease;
}
.student-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px -4px rgba(0,0,0,0.1) !important;
}

/* Animación de entrada/salida de tarjeta de estudiante */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>
